import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import PropTypes from 'prop-types';
import { Controller } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import TextDivider from '../../../elements/text-divider/TextDivider';
import { StyledInputsContainer } from '../styles';

const AdditionalParamsFormSection = ({ control, errors, parser }) => {
  const { t } = useTranslation();

  const dismaxFields = ['alt', 'qf', 'mm', 'pf', 'ps', 'qs', 'tie', 'bq', 'bf'];
  const edismaxFields = ['uf', 'pf2', 'pf3', 'ps2', 'ps3', 'boost'];

  return (
    <>
      <TextDivider>
        {t('search.additionalParams', { ns: 'sectionTitles' })}
      </TextDivider>

      <StyledInputsContainer>
        {dismaxFields.map((fieldName) => (
          <Box key={fieldName}>
            <Controller
              name={`settings.query.jsonQuery.params.${fieldName}`}
              control={control}
              defaultValue=""
              render={({ field }) => (
                <TextField
                  {...field}
                  label={t(`search.${fieldName}`, { ns: 'fields' })}
                  variant="outlined"
                  size="small"
                  fullWidth
                  inputProps={{ 'aria-label': fieldName }}
                  error={
                    !!errors?.settings?.query?.jsonQuery?.params?.[fieldName]
                  }
                  helperText={
                    errors?.settings?.query?.jsonQuery?.params?.[fieldName]
                      ?.message
                  }
                />
              )}
            />
          </Box>
        ))}
        {parser === 'edismax' &&
          edismaxFields.map((fieldName) => (
            <Box key={fieldName}>
              <Controller
                name={`settings.query.jsonQuery.params.${fieldName}`}
                control={control}
                defaultValue=""
                render={({ field }) => (
                  <TextField
                    {...field}
                    label={t(`search.${fieldName}`, { ns: 'fields' })}
                    variant="outlined"
                    size="small"
                    fullWidth
                    inputProps={{ 'aria-label': fieldName }}
                    error={
                      !!errors?.settings?.query?.jsonQuery?.params?.[fieldName]
                    }
                    helperText={
                      errors?.settings?.query?.jsonQuery?.params?.[fieldName]
                        ?.message
                    }
                  />
                )}
              />
            </Box>
          ))}
      </StyledInputsContainer>
    </>
  );
};

AdditionalParamsFormSection.propTypes = {
  control: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
  parser: PropTypes.string.isRequired,
};

export default AdditionalParamsFormSection;
